/**
 * @typedef {object} FontFamily
 * @property {'HeadlineBlack'} HeadlineBlack - Headline Black font
 * @property {'Roboto'} Roboto - Roboto font
 * @property {'default'} Default - Default font
 */

export interface FontMetrics {
    emSquare: number;
    capHeight: number;
    ascender: number;
    descender: number;
}

export interface FontFamilies {
    HeadlineBlack: 'HeadlineBlack';
    Roboto: 'Roboto';
    Default: 'default';
}

type FontFamily = FontFamilies[keyof FontFamilies];

export const FontFamily: FontFamilies = {
    HeadlineBlack: 'HeadlineBlack',
    Roboto: 'Roboto',
    Default: 'default',
};

/**
 * This is the place where the font metric components should be added.
 * You need the Em square (units per em), Cap (capital letter height),
 * ascender (height above baseline) and descender (depth below baseline) height.
 * For extracting font metric components, Capsize can be used:
 * https://seek-oss.github.io/capsize/
 * Font needs to be uploaded there and it reads the values from the font file.
 * The values provided can be used directly here, no conversion needed.
 */

export type FontMetricsMap = Record<FontFamily, FontMetrics>;

const headlineBlackFontMetrics: FontMetrics = {
    emSquare: 1000,
    capHeight: 700,
    ascender: 962,
    descender: 376,
};

export const fontMetrics: FontMetricsMap = {
    [FontFamily.HeadlineBlack]: headlineBlackFontMetrics,
    [FontFamily.Roboto]: {
        emSquare: 2048,
        capHeight: 1456,
        ascender: 1900,
        descender: 500,
    },
    [FontFamily.Default]: { ...headlineBlackFontMetrics },
};
